// Suppliers Vuex

import state from './supplierStates.js'
import * as getters from './supplierGetters.js'
import * as mutations from './supplierMutations.js'
import * as actions from './supplierActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
